/**
 * The ready-made iPhone Shortcut (I2): built once from `docs/ios-shortcut.md` and shared through iCloud, so
 * it holds nothing personal — on its first run it scans the setup code from Settings (the capture address and
 * a capture-only token) and keeps it in `drang.txt` in the Shortcuts folder of iCloud Drive.
 *
 * Empty until the shortcut is published; Settings then shows the recipe instead of the QR code.
 */
export const IOS_SHORTCUT_URL = "";

/** What the setup QR code holds: read by the shortcut with "Get Dictionary from Input". */
export function setupCode(origin: string, token: string): string {
  return JSON.stringify({ drang: 1, url: `${origin}/api/v1/capture`, token });
}
